<template>
  <div class="mx-auto max-w-4xl p-4"></div>
</template>
